app.directive('destinationSectionTcatSevenEleven', [
  'tcatSevenElevenService',
  'multiCheckoutService',
  function (tcatSevenElevenService, multiCheckoutService) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.tcat-seven-eleven.html'),
      scope: {
        store: '=',
        disabled: '=',
        cartTagIds: '=',
        errorMessage: '=',
        updateDestination: '<',
        contractCode: '@',
        tcatStoreCategory: '@',
      },
      link: function (scope) {
        scope.actionUrl = () => tcatSevenElevenService.getEMapUrl();
        scope.callbackUrl = () => tcatSevenElevenService.getEMapCallbackUrl();
        scope.eMapFormId = () =>
          `multi_checkout_tcat_seven_${scope.cartTagIds.join('-')}`;

        scope.onEMapSubmitClick = (event) => {
          event.preventDefault();
          scope
            .updateDestination()
            .then(() =>
              multiCheckoutService.saveSessionData({
                cart_tag_ids: scope.cartTagIds,
              }),
            )
            .then(() => {
              $(`#${scope.eMapFormId()}`).submit();
            })
            .catch(() => {
              console.error('unable to open e-map of tcatseven eleven.');
            });
        };
      },
    };
  },
]);
